import { DataContentSettings } from '@/types/contentTypes'
import { type ContentProps } from '../_sections/sections'
import { ApiSectionSection } from '@/types/contentTypes'
import Image from '../ui/image'
import Background from '../ui/background'

export function Content({
	children,
	contentSettings,
}: {
	children: React.ReactNode
	contentSettings?: DataContentSettings['attributes']
}) {
	let maxWidth = ''
	switch (contentSettings?.max_width) {
		case 'small':
			maxWidth = 'max-w-sm'
			break
		case 'medium':
			maxWidth = 'max-w-xl'
			break
		case 'large':
			maxWidth = 'max-w-xxl '
			break
		case 'full':
			maxWidth = 'max-w-full min-w-0   w-full'
			break
		default:
			maxWidth = 'container'
			break
	}

	let align_content = ''

	switch (contentSettings?.align_content) {
		case 'left':
			align_content = 'items-start'
			break
		case 'center':
			align_content = 'items-center mx-auto'
			break
		case 'right':
			align_content = 'items-end'
			break
		case 'stretch':
			align_content = 'items-stretch'
			break
		default:
			align_content = 'items-center'
			break
	}

	let verticalSpacing = ''

	switch (contentSettings?.after_row_spacing) {
		case 'none':
			verticalSpacing = 'py-0'
			break
		case 'tiny':
			verticalSpacing = 'py-2'
			break
		case 'small':
			verticalSpacing = 'py-4'
			break
		case 'medium':
			verticalSpacing = 'py-8'
			break
		case 'large':
			verticalSpacing = 'py-16'
			break
		case 'huge':
			verticalSpacing = 'py-32'
			break
		default:
			verticalSpacing = 'py-0'
			break
	}

	return (
		<div
			className={`${maxWidth} ${align_content} ${verticalSpacing} flex flex-col self-stretch`}
		>
			{children}
		</div>
	)
}

export default function Row({
	children,
	rowSettings,
}: {
	children: any
	rowSettings: ApiSectionSection['attributes']
}) {
	const full_width = rowSettings.full_width ?? false
	const after_row_spacing = rowSettings.after_row_spacing ?? 'default'
	const vertical_spacing = rowSettings.vertical_spacing ?? 'default'
	const title = rowSettings.title ?? ''
	const background = rowSettings.background ?? null

	console.log('Row -> background', background, title)

	const rowClasses = getRowClasses({
		full_width,
		after_row_spacing,
		vertical_spacing,
	})

	if (background)
		return (
			<Background content={background}>
				<section id={title} className={`flex flex-col gap-6 ${rowClasses} `}>
					{children}
				</section>
			</Background>
		)

	return (
		<section id={title} className={`flex flex-col gap-6 ${rowClasses}`}>
			{children}
		</section>
	)
}

function getRowClasses({
	full_width,
	after_row_spacing,
	vertical_spacing,
}: {
	full_width: boolean
	after_row_spacing: 'small' | 'medium' | 'large' | 'none' | 'default'
	vertical_spacing: 'small' | 'medium' | 'large' | 'none' | 'default'
}) {
	const spacingClasses = {
		small: 'mb-12',
		medium: 'mb-36',
		large: 'mb-48',
		none: 'mb-0',
		default: 'mb-36',
	}

	const verticalSpacingClasses = {
		small: 'py-8',
		medium: 'py-16',
		large: 'py-32',
		none: 'py-0',
		default: 'py-16',
	}

	const spacingClass =
		spacingClasses[after_row_spacing] || spacingClasses.default

	const verticalSpacing =
		verticalSpacingClasses[vertical_spacing] || verticalSpacingClasses.default
	const rowClasses = full_width
		? `relative ${spacingClass} flex-1 grow `
		: `relative flex-1 grow  ${spacingClass} lg:px-0 lg:mx-auto lg:max-w-xxl items-center`

	return `${rowClasses} ${verticalSpacing}`
}
